import * as React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import isEmail from "validator/lib/isEmail";
import validator from "validator";
import isStrongPassword = validator.isStrongPassword;
import { useTryLoginMutation, useTryRegisterMutation } from "../../store";

export const RegisterForm = ({
  open,
  id,
  close
}: {
  open: boolean;
  id?: string;
  close: () => void;
}) => {
  const [deviceId, setDeviceId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [register, registerResult] = useTryRegisterMutation();
  const [login, loginResult] = useTryLoginMutation();

  const initErrors = {
    deviceId: "",
    name: "",
    email: "",
    password: ""
  };

  useEffect(() => {
    if (id) {
      setDeviceId(id);
    }
  }, [id]);

  useEffect(() => {
    if (registerResult.isSuccess) {
      login({ email, password });
    } else if (registerResult.isError) {
      if ("status" in registerResult.error) {
        const { status, data } = registerResult.error;
        if (status === 404) {
          setErrors({ ...initErrors, deviceId: "Tarkasta laitteen ID" });
        } else if (status === 400) {
          setErrors({ ...initErrors, email: "Sähköposti on jo käytössä" });
        }
      }
    }
  }, [registerResult]);

  const [errors, setErrors] = useState(initErrors);

  const handleRegister = () => {
    const err = initErrors;
    let errors = false;

    if (deviceId.length < 1) {
      errors = true;
      err.deviceId = "Anna laitteen ID";
    }

    if (name.length < 4) {
      errors = true;
      err.name = "Tarkasta nimesi";
    }

    if (!isEmail(email)) {
      errors = true;
      err.email = "Tarkasta sähköpostiosoitteesi";
    }

    if (
      !isStrongPassword(password, {
        minLength: 8,
        minNumbers: 1,
        minUppercase: 1,
        minLowercase: 1,
        minSymbols: 0
      })
    ) {
      errors = true;
      err.password =
        "Salasanan tulee sisältää sekä isoja että pieniä kirjaimia, numeroita ja olla vähintään 8 merkkiä pitkä";
    }
    if (!errors) {
      register({ deviceId, name, email, password });
      setErrors(initErrors);
    } else {
      setErrors(err);
    }
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Lisää käyttäjätili</DialogTitle>
      <DialogContent>
        <TextField
          error={Boolean(errors.deviceId)}
          helperText={errors.deviceId}
          autoFocus
          margin="dense"
          id="deviceId"
          label="Laitteen ID"
          type="text"
          fullWidth
          variant="standard"
          onChange={event => setDeviceId(event.target.value)}
          value={deviceId}
        />
        <TextField
          error={Boolean(errors.name)}
          helperText={errors.name}
          autoFocus
          margin="dense"
          id="name"
          label="Nimi"
          type="text"
          fullWidth
          variant="standard"
          onChange={event => setName(event.target.value)}
          value={name}
        />
        <TextField
          error={Boolean(errors.email)}
          helperText={errors.email}
          autoFocus
          margin="dense"
          id="email"
          label="Sähköpostiosoite"
          type="text"
          fullWidth
          variant="standard"
          onChange={event => setEmail(event.target.value)}
          value={email}
        />
        <TextField
          error={Boolean(errors.password)}
          helperText={errors.password}
          autoFocus
          margin="dense"
          id="password"
          label="Salasana"
          type="password"
          fullWidth
          variant="standard"
          onChange={event => setPassword(event.target.value)}
          value={password}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRegister}>Luo tili</Button>
      </DialogActions>
    </Dialog>
  );
};
